"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const isActiveIcon_1 = __importDefault(require("./isActiveIcon"));
const findIcon_1 = __importDefault(require("./findIcon"));
const icons_1 = require("../../atoms/icons");
const comparePaths = (activePath, path) => activePath === path;
// TODO: simplify the isActiveIcon logic
const navIconToView = (onClick, activePath) => (icon) => {
    const handleClick = () => onClick(icon.path);
    const isActive = comparePaths(activePath, icon.path);
    return ((0, jsx_runtime_1.jsx)(Tab, { "data-cy": "bottomBar-tab-" + icon.path.replace("/", "") + "-mobile", isActive: icon.path === "/body"
            ? /nutrition|training|recovery/.test(activePath)
            : isActive, onClick: handleClick, children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { icon: (0, isActiveIcon_1.default)()((0, findIcon_1.default)(icon.iconName)), size: "lg", color: "lighten-grey", shape: "rectangleBig" }, void 0) }, void 0) }, icon.path));
};
exports.default = ({ onClick, iconsNameWithPaths, bodyIconsNameWithPaths, activePath, showMobileStackedNav }) => {
    const prepareNavIconToView = navIconToView(onClick, activePath);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { css: {
            flexDirection: "column"
        }, children: [showMobileStackedNav && ((0, jsx_runtime_1.jsx)(StackedNavWrapper, { children: bodyIconsNameWithPaths.map(prepareNavIconToView) }, void 0)), (0, jsx_runtime_1.jsx)(Wrapper, { children: iconsNameWithPaths.map(prepareNavIconToView) }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  display: flex;
  height: 50px;
  width: 100%;
  z-index: 5;
  position: relative;
`;
const StackedNavWrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  display: flex;
  height: 50px;
  width: 100%;
  z-index: 5;
  position: absolute;
  top: -100%;
`;
const Tab = styled_components_1.default.div `
  align-items: center;

  display: flex;
  flex: 1;
  justify-content: center;

  & > div {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 60%;
    ${({ isActive, theme }) => isActive ? `border-bottom: 3px solid ${theme.colors.greyBase}` : ""};
  }

  svg {
    ${({ isActive, theme }) => isActive ? `color: ${theme.colors.greyBase}` : ""};
  }
`;
//# sourceMappingURL=MemberActivityNavigationMobile.js.map